// tableSelection.js — منطق نقي للتحديد اليدوي من الجدول الرئيسي (ExpectedToday).
// (ب) البنود 4-9 — يُستهلك من ExpectedToday.jsx. لا حالة React هنا (قابل للاختبار).

// البند 4 — تبديل صف واحد بمفتاح الجوال.
export function toggleRowPhone(selected, phone) {
  const n = new Set(selected);
  if (!phone) return n;
  if (n.has(phone)) n.delete(phone); else n.add(phone);
  return n;
}

// البند 5 — «تحديد الكل» يشمل المعروض حاليًا فقط (لا كل القاعدة):
// إن كان كل المعروض محدَّدًا ⇒ إلغاء تحديدهم؛ وإلا ⇒ تحديدهم — دون المساس ببقية القاعدة.
export function toggleAllShown(selected, shownRows) {
  const phones = (shownRows || []).map((r) => r && r.phone).filter(Boolean);
  const n = new Set(selected);
  const allOn = phones.length > 0 && phones.every((p) => n.has(p));
  if (allOn) phones.forEach((p) => n.delete(p));
  else phones.forEach((p) => n.add(p));
  return n;
}

// البند 7 — بناء قائمة المحددين من فئة معيّنة بالترتيب، بمقدار التحديد بالضبط.
export function selectedFrom(list, selected) {
  return (list || []).filter((r) => r && r.phone && selected.has(r.phone));
}

// عدّاد المحددين ضمن فئة (للعرض فوق الجدول — البند 6).
export function countSelectedIn(list, selected) {
  return selectedFrom(list, selected).length;
}

// البند 9 — تحديد فارغ (يُستدعى عند تغيير التاريخ/الفلتر/الفرع/التبويب).
export function emptySelection() {
  return new Set();
}
